/* System defined core library */
import { Injectable } from '@angular/core';

/* User defined library/components */
import { SelectedExamDetailService } from '../../scheduling/shared/services/selected-exam-detail.service';
import { DynamicComponentService } from './dynamic.component.service';

/* User defined models */
import { ProSchedulerDropdown } from '../models/common/dropdown.model';
import { DynamicFormBase } from '../models/common/dynamic-form-base.model';
import { Candidate } from '../models/scheduling/candidate.model';


@Injectable()
export class DemographicsService {

  constructor(
    private dynamicComponentService: DynamicComponentService,
    private selectedExamDetailService: SelectedExamDetailService
  ) {

  }

  canSkipDemographicPage(orchestrationData: any[], candidate: Candidate): boolean {
    if (
      // can only skip if LPI or configured to skip
      (!!this.selectedExamDetailService.lpiCandidateGuid || this.selectedExamDetailService.skipProfileConfig) &&
      // can only skip with a candidate that has default details
      !!candidate && !!candidate.defaultDetails &&
      // can only skip if 'Candidate Profile' is provided
      !!orchestrationData.filter(response => response.name === 'Candidate Profile').length
    ) {
      // get controls with additional required logic for country/state/county/post
      const dynamicInputControls: DynamicFormBase<any>[] = this.dynamicComponentService.formatCandiateProfileMetaData(orchestrationData);

      // set value for every input
      dynamicInputControls.forEach(i => {
        i.setValue(!!candidate.defaultDetails[i.key.toLowerCase()] ? candidate.defaultDetails[i.key.toLowerCase()] : candidate.defaultDetails[i.fieldMap.toLowerCase()]);
        if (i.controlType === 'dropdown') {
          (<ProSchedulerDropdown>i).setSelectedOptionInternally();
        }
        if (i.key.toLowerCase() === 'validate_email') {
          const email = dynamicInputControls.find(d => d.key.toLowerCase() === 'email');
          i.setValue(!!candidate.defaultDetails[email.key.toLowerCase()] ? candidate.defaultDetails[email.key.toLowerCase()] : candidate.defaultDetails[email.fieldMap.toLowerCase()])
        }
        if (i.key.toLowerCase() === 'firstname_rsa') {
          i.setValue(!!candidate.defaultDetails['first_name'] ? candidate.defaultDetails['first_name'] : undefined);
        }
        if (i.key.toLowerCase() === 'lastname_rsa') {
          i.setValue(!!candidate.defaultDetails['last_name'] ? candidate.defaultDetails['last_name'] : undefined);
        }
      });

      // prune inputs we care about down to all values marked as required and visible
      const reqDemographics = dynamicInputControls.filter(i => i.required && i.displayFlag);

      if (!this.selectedExamDetailService.lpiCandidateGuid) {
        // for skip config all required values must be read only and have a value
        return reqDemographics.every(d => d.readOnly && !!d.value);
      } else if (reqDemographics.length) {
        // for lpi we must have required demos and all required values must  have a value
        const canSkipPage = reqDemographics.every(d => !!d.value);
        this.selectedExamDetailService.shouldUpdateDemographics = !canSkipPage;
        return canSkipPage;
      }
    }
    return false;
  }
}
